export const AUTH_SESSION_STORAGE_KEY =
    "user_auth_v2";

function isValidSession(userData) {
    return Boolean(
        userData &&
        typeof userData === "object" &&
        userData.loggedIn === true &&
        userData.auth &&
        typeof userData.auth === "object" &&
        typeof userData.auth.access_token ===
            "string" &&
        userData.auth.access_token.length > 0 &&
        typeof userData.auth.refresh_token ===
            "string" &&
        userData.auth.refresh_token.length > 0 &&
        userData.info &&
        typeof userData.info === "object"
    );
}

function clear() {
    try {
        localStorage.removeItem(
            AUTH_SESSION_STORAGE_KEY
        );
    } catch {
        return;
    }
}

function read() {
    try {
        const encodedUserData =
            localStorage.getItem(
                AUTH_SESSION_STORAGE_KEY
            );

        if (!encodedUserData) {
            return null;
        }

        const decodedUserData =
            Buffer.from(
                encodedUserData,
                "base64"
            ).toString("utf8");

        const userData =
            JSON.parse(
                decodedUserData
            );

        if (!isValidSession(userData)) {
            clear();

            return null;
        }

        return userData;
    } catch {
        clear();

        return null;
    }
}

function save(userData) {
    if (
        !userData ||
        typeof userData !== "object"
    ) {
        throw new TypeError(
            "userData must be an object"
        );
    }

    const serializedUserData =
        JSON.stringify(userData);

    const encodedUserData =
        Buffer.from(
            serializedUserData
        ).toString("base64");

    localStorage.setItem(
        AUTH_SESSION_STORAGE_KEY,
        encodedUserData
    );
}

export const browserAuthSessionStore =
    Object.freeze({
        read,
        save,
        clear,
    });
